export const isNumeric = n => !isNaN(n);